import { render, staticRenderFns } from "./inventoryBalance.vue?vue&type=template&id=2acdb372&scoped=true&"
import script from "./inventoryBalance.vue?vue&type=script&lang=js&"
export * from "./inventoryBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdb372",
  null
  
)

export default component.exports